import { Button, Fab, Typography } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { Check } from '@material-ui/icons';
import { BlobProvider } from '@react-pdf/renderer';
import React from 'react';

const SucessoRetirada = ({ totalCartelas, totalSelos, onClick, impressao }) => {
    const [urlPdf, setUrlPdf] = React.useState();
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
                minHeight: '50vh',
                minWidth: '50vw',
                alignItems: 'center',
            }}
        >
            <Fab color="primary" style={{ backgroundColor: green[500] }}>
                <Check />
            </Fab>
            {totalCartelas > 0 && (
                <Typography variant="h5">{totalCartelas} Kits</Typography>
            )}
            {totalSelos > 0 && (
                <Typography variant="h5">{totalSelos} Selos</Typography>
            )}
            <Typography>Retirados com Sucesso !</Typography>
            <div>
                <BlobProvider document={impressao}>
                    {({ blob, url, loading, error }) => {
                        if (url) setUrlPdf(url);
                        return loading ? (
                            <div>Carregando impressão ...</div>
                        ) : null;
                    }}
                </BlobProvider>
            </div>
            {urlPdf && (
                <>
                    <div>
                        <a
                            href={urlPdf}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Imprimir
                        </a>
                    </div>
                    <div>
                        <Button onClick={onClick}>OK</Button>
                    </div>
                </>
            )}
        </div>
    );
};

SucessoRetirada.defaultProps = {
    onClick: console.warn,
};

export default SucessoRetirada;
